import React, { Component } from 'react';
import Translation from '../../../../common/translation/translation.component';
import { HistoryLayout } from '../../../../common/history/history-layout.component';
import OrderHistory from '../order-history/order-details-history';

import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { orderHistoryActions } from '../../../../../store/external/order/history/order-history.reducer'
import { MODAL_CUSTOM_MESSAGE } from "../../../../../constants/external-constants";

class OrderHistoryComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            enableSearchBox: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        };
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }


    onClickExtract = () => {
        const { orderDetailsId, extractOrderHistoryLogs, requestTypeId, quotationRequestId } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractOrderHistoryLogs(orderDetailsId, quotationRequestId, requestTypeId);
        }
    }  

    render() {
        return (
            <>
                <Translation
                    getOnlyText={true}
                    onChangeTranslation={() => { }}
                    translationKey={"export_alert_message"} />

                <HistoryLayout
                    listHistoryTab={this.props.listHistoryTab}
                    selectedIndex={[]}
                    extractAction={this.onClickExtract}
                    displaySearchBox={this.displaySearchBox}

                    {...this.props.roles}
                    hideCustomColumn={true}
                >

                    <OrderHistory
                        orderId={this.props.orderDetailsId}
                        quotationRequestId={this.props.quotationRequestId}
                        isColSearchShow={this.state.enableSearchBox}
                        requestTypeId={this.props.requestTypeId}
                    />
                </HistoryLayout>
            </>
        );
    }
}




export default connect(
    state => {
        const { } = state;

        return {

        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, orderHistoryActions),
        dispatch
    )
)(OrderHistoryComponent);